<template>
  <v-row>
    <v-col cols="12" v-if="hosting_error">
      <v-card class="app-card" text>
        <v-card-text>
          <p class="mb-0">{{ hosting_error }}</p>
        </v-card-text>
      </v-card>
    </v-col>
    <template v-else>
      <v-col cols="12">
        <service-limits :loading="loading"></service-limits>
        <service-domain-server-info :loading="loading" class="pb-0 pt-3"></service-domain-server-info>
        <service-info></service-info>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ServiceInfo from 'Components/Services/Hosting/Common/ServiceDetails'
import ServiceLimits from 'Components/Services/Hosting/Common/ServiceLimits'
import ServiceDomainServerInfo from 'Components/Services/Hosting/Common/ServiceDomainServerInfo.vue'

export default {
  name: 'InfoView',
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  components: {
    ServiceInfo,
    ServiceLimits,
    ServiceDomainServerInfo,
  },
  computed: mapGetters(['hosting', 'hosting_detail', 'hosting_error']),
  methods: {
    ...mapActions(['getHostingDetail']),
  },
}
</script>
